import * as React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router-dom";
import {Panel} from "react-bootstrap";
import "react-dates/lib/css/_datepicker.css";
import "font-awesome/less/font-awesome.less";
import "hint.css/hint.css";

import {placeOrder} from "../actions/hotels";
import {ApplicationState} from "../reducers";
import "./styles/hotels.less";
import {Order} from "../models/order";

interface Props extends RouteComponentProps<any> {
    order: Order;
}

class Confirm extends React.Component<Props> {

    public render(): JSX.Element {
        return <div className="hotel-listing-c">
            <div className="package-container">
                <div className="checkout">
                    {this.renderCart()}
                </div>
            </div>
        </div>;
    }

    public renderCart(): JSX.Element {
        if (!this.props.order || !this.props.order.user) {
            this.props.history.push("/");
            return null;
        }
        const order = this.props.order;

        return (
            <Panel bsStyle="primary" className="cart">
                <Panel.Heading>Your Order Has Been Received</Panel.Heading>
                <Panel.Body>
                    <p>Your order number is <strong>{order.orderNumber}</strong>.</p>
                    <p>We sent a confirmation email to <strong>{order.user.email}</strong>.</p>
                    <p>Thank you!</p>
                </Panel.Body>
            </Panel>
        );
    }
}

const connected = connect((state: ApplicationState) => ({
    order: state.hotels.order
}), {
    placeOrder
})(Confirm);

export default withRouter<any>(connected);



// WEBPACK FOOTER //
// ./src/components/Confirm.tsx